<template>
<div id="contents">
  <div id="players">

    <p class="page_close hover" v-if="referrer == 'company_index'"><router-link v-bind:to="{name: 'company_index'}"><img src="../assets/img/common/page/close_icon.png" width="50" alt="閉じるボタン" ></router-link></p>

    <p class="page_close hover" v-else><router-link v-bind:to="{name: 'players_index'}"><img src="../assets/img/common/page/close_icon.png" width="50" alt="閉じるボタン" ></router-link></p>

    <div id="players_contents">
      <div id="players_show" v-if="player">

        <div id="players_show_main" class="players_show_contents" v-bind:class="{ ceo_main: new_ceo }">

          <div v-if="!new_ceo" id="players_show_main_name">
            <p class="job">{{player.job_type}}</p>
            <h1>{{player.title}}</h1>
            <p class="name_en">{{player.staff_name_en}}</p>
          </div><!-- #players_show_main_name -->

          <p v-if="ceo && !new_ceo" id="top_message_title"><img src="../assets/img/players/top_message.png" width="237" alt="TOP MESSAGE" ></p>
          <p v-if="new_ceo" id="top_message_new_title"><img src="../assets/img/players/top_message_large.png" width="303" alt="TOP MESSAGE" ></p>

          <p v-if="new_ceo" id="ceo_image"><img src="../assets/img/players/wakabayashi.png" width="100%" alt="若林 邦彦" ></p>
          <h3 v-if="new_ceo" id="top_message_kv_copy">いいものを<br />創り続けるということ</h3>

          <p v-if="!new_ceo" id="players_show_main_image" v-bind:style="{ backgroundImage: 'url(' + player.kv_image + ')' }"></p>
          <p v-if="!new_ceo" id="players_show_main_num" v-bind:data="this.player.staff_number"></p>
        </div><!-- #players_show_main -->

        <div id="players_show_job_list" v-if="this.player.job_list && !ceo">
          <p v-html="works_list"></p>
        </div><!-- #players_show_job_list -->

        <div id="players_show_body">

          <p id="top_message_copy" v-if="ceo && !new_ceo">「トップクリエイター集団」<br />を作るという挑戦。</p>

          <div id="mynavi_interview_pdf" v-if="this.$route.params.id == 8830">
            <p>「マイナビ　就活準備　完全ガイド」<br />掲載のインタビュー<a href="http://jobebook.mynavi.jp/library/21/start/html5.html#page=189" target="_blank"><br />⇒こちら</a></p>
          </div>

          <div class="palyers_show_quetion players_show_contents" v-bind:class="{ ceo_message: new_ceo }">
            <h2 v-if="ceo && !new_ceo">会社としての強み、大切にしていること</h2>
            <h2 v-if="!ceo">仕事とやり甲斐</h2>

            <div class="answer">
              <p>{{player.job_content}}</p>
            </div><!-- .answer -->
          </div><!-- .palyers_show_quetion -->

          <div v-if="!new_ceo" class="palyers_show_quetion players_show_contents">
            <h2 v-if="ceo">今後の展望、どんな未来を形にしていくか</h2>
            <h2 v-else>ヒットコンテンツをつくるために心がけていること</h2>
            <div class="answer">
              <p>{{player.hit_contents}}</p>
            </div><!-- .answer -->
          </div><!-- .palyers_show_quetion -->

          <div v-if="!new_ceo" class="palyers_show_quetion players_show_contents">
            <h2 v-if="ceo">社長としてチャレンジしたいこと</h2>
            <h2 v-else>目指しているPLAYer像</h2>
            <div class="answer">
              <p>{{player.aim_at}}</p>
            </div><!-- .answer -->
          </div><!-- .palyers_show_quetion -->


          <div v-if="!ceo" id="players_show_staff_column" class="players_show_contents">
            <h3>最近のPLAYな出来事</h3>
            <div id="players_show_staff_column_inner">
              <p v-bind:class="{ text_only: player.event_image }">{{player.event_text}}</p>
              <p><img :src="player.event_image" width="100%" /></p>
            </div><!-- #palyers_show_staff_column_inner -->
          </div><!-- #palyers_show_staff_column -->

          <div v-if="new_ceo" id="ceo_name_wrap">
            <div id="ceo_name">
              <p>テレビ朝日映像株式会社</p>
              <p>代表取締役社長 兼<br />エグゼクティブプロデューサー</p>
              <p class="name"><img src="../assets/img/players/wakabayashi_name.png" width="117" /></p>
            </div>
          </div>

          <div id="players_show_profile" class="players_show_contents" v-bind:class="{ ceo_profile: new_ceo }">
            <h2>プロフィール</h2>
            <p>{{player.profile}}</p>
            <div class="awards" v-if="player.awards">
              <dt>受賞歴：</dt>
              <dd v-html="player.awards"></dd>
            </div><!-- .awards -->
          </div><!-- #palyers_show_profile -->

          <div id="players_show_program" v-if="player.program_list && !ceo" class="players_show_contents">
            <h2>担当番組</h2>
            <slick ref="slick" :options="slickOptions">
              <p class="slider_item" v-for="program in player.program_list" :key="program.post_id">
                <router-link v-bind:to="{ name : 'works_program_show', params : { id: program.post_id }}" class="hover"><img :src="program.img_path" width="100%" /></router-link>
              </p>
            </slick>
            <ul id="slider_arrow">
              <li><a v-on:click="prev"><img src="../assets/img/common/page/arrow.png" width="11" alt="右矢印" ></a></li>
              <li><a v-on:click="next"><img src="../assets/img/common/page/arrow.png" width="11" alt="右矢印" ></a></li>
            </ul>
          </div><!-- #players_show_program -->

        </div><!-- #palyers_show_body -->

        <div id="players_show_other_palyer" v-if="!ceo" class="players_show_contents">
          <h3><img src="../assets/img/players/other_player_title.png" width="300" alt="OTHER PLAYers" /></h3>
          <div id="players_show_other_palyer_inner">

            <div v-for="other_player in player.other_player_list" :key="other_player.post_id" class="player_card hover">
              <p class="other_player_image"><router-link v-bind:to="{name: 'players_show', params: {id: other_player.post_id}}" v-bind:style="{ backgroundImage: 'url(' + other_player.img_path + ')' }"></router-link></p>
              <div class="player_card_inner">
                <h3>
                  <router-link v-bind:to="{name: 'players_show', params: {id: other_player.post_id}}">
                    <span>{{other_player.name}}</span>
                    <span>{{other_player.staff_name_en}}</span>
                  </router-link>
                </h3>
                <p class="player_num js-player_num" v-bind:data="other_player.staff_number"></p><!-- .player_num -->
              </div><!-- .player_card_inner -->
            </div><!-- .player_card -->

          </div><!-- #palyers_show_other_palyer_inner -->
        </div><!-- #palyers_show_other_palyer -->
      </div><!-- #players_show -->
    </div><!-- #players_contents -->

    <ul id="page_nav" v-if="player && !ceo">

      <p class="hover" v-if="player.next_post_id && player.next_post_id != '8010' && player.next_post_id != '9784'"><router-link v-bind:to="{name: 'players_show', params: {id: player.next_post_id}}"><img src="../assets/img/common/page/arrow.png" width="11" alt="右矢印" ></router-link></p>
      <p v-else></p>

      <p class="hover" v-if="player.prev_post_id"><router-link v-bind:to="{name: 'players_show', params: {id: player.prev_post_id}}"><img src="../assets/img/common/page/arrow.png" width="11" alt="右矢印" ></router-link></p>
      <p v-else></p>

    </ul><!-- #page_nav -->

  </div><!-- #players -->

</div><!-- #contents -->
</template>

<script>
import Slick from 'vue-slick';
export default {
  name: 'players_show',
  data() {
    return {
      api_url: this.$parent.api_base_url+'/api/players/show.php',
      loading: true,
      player: null,
      referrer: this.$attrs.referrer,
      number_image_src: [
        require("../assets/img/common/n_0.png"),
        require("../assets/img/common/n_1.png"),
        require("../assets/img/common/n_2.png"),
        require("../assets/img/common/n_3.png"),
        require("../assets/img/common/n_4.png"),
        require("../assets/img/common/n_5.png"),
        require("../assets/img/common/n_6.png"),
        require("../assets/img/common/n_7.png"),
        require("../assets/img/common/n_8.png"),
        require("../assets/img/common/n_9.png")
      ],
      slickOptions: {
        arrows: false,
      },
      error: null
    }
  },
  components: {
    Slick
  },
  methods: {
    next() {
      this.$refs.slick.next();
    },
    prev() {
      this.$refs.slick.prev();
    },
    fetch_player(){
      this.$axios
        .get(this.api_url ,{
          params: {
            id: this.$route.params.id
          }
        })
        .then(response => {
          this.player = response.data.item[0]
        })
        .catch(error => {
          console.log(error)
          this.error = true
        })
        .finally(() => function(){
        })
    }
  },
  watch: {
    '$route' (to, from) {
      this.fetch_player()
    }
  },
  computed: {
    works_list: function(){
      return this.player.job_list.replace(/\n/g, '<br/>');
    },
    ceo: function () {
      console.log(this.player.staff_number)
      if(this.player.staff_number == '1'){
        return true
      }else{
        return false
      }
    },
    new_ceo: function () {
      if(this.$route.params.id == '9784'){
        return true
      }else{
        return false
      }
    }
  },
  mounted () {
    var queue = new createjs.LoadQueue(true);
    var manifest = this.number_image_src;
    var fetch_player = this.fetch_player
    queue.loadManifest(manifest,true);
    queue.addEventListener("complete",function(){
      fetch_player()
    });

  },
  beforeUpdate() {
        if (this.$refs.slick) {
            this.$refs.slick.destroy()
        }
  },
  updated (){
    //画像の置き換え_main
    var number_image_list = this.number_image_src
    replaceNumber($("#players_show_main_num"))
    $('.js-player_num').each(function(){
      replaceNumber($(this))
    });
    function replaceNumber($dom){
      $dom.html('');
      var staff_num = $dom.attr('data');
      staff_num = ('0000000000' + staff_num).slice(-3);
      $dom.append('<img src="'+number_image_list[staff_num.charAt(0)]+'">');
      $dom.append('<img src="'+number_image_list[staff_num.charAt(1)]+'">');
      $dom.append('<img src="'+number_image_list[staff_num.charAt(2)]+'">');
    }//replaceNumber
    this.$nextTick(function () {
      if (this.$refs.slick) {
        this.$refs.slick.create(this.slickOptions)
      }
    })
    this.$emit('page_fade')
  }
}
</script>
<style lang="css">
  @import "../../node_modules/slick-carousel/slick/slick.css";
</style>
<style scoped lang="sass">


</style>



// WEBPACK FOOTER //
// src/components/players_show.vue